import React, { useEffect, useState } from 'react';
import { ArrowBack, Delete } from '@mui/icons-material';
import { Box, Paper, Typography, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ResetButton from '../../Common_Components/ResetButton';
import SaveButton from '../../Common_Components/SaveButton';
import CustomInputField from '../../Common_Components/CustomInputField';
import axiosInstance from '../../axios/axios';
import { Toast } from '../../Common_Components/Toast';

const EmailSettings = () => {
    const navigate = useNavigate();
    const [settings, setSettings] = useState([
        { name: '', email: '', designation: '' },
    ]);

    const handleBackClick = () => navigate(-1);

    const handleInputChange = (index, field, value) => {
        const updatedSettings = [...settings];
        updatedSettings[index][field] = value;
        setSettings(updatedSettings);
    };

    const addNewPerson = () => {
        setSettings([...settings, { name: '', email: '', designation: '' }]);
    };

    const deletePerson = (index) => {
        const updatedSettings = settings.filter((_, i) => i !== index);
        setSettings(updatedSettings);
    };

    const resetSettings = () => {
        setSettings([{ name: '', email: '', designation: '' }]);
    };
    useEffect(() => {
        // Fetch saved settings from the backend
        const fetchSettings = async () => {
            try {
                const response = await axiosInstance.get('/emailsettings/list');
                const { success, emailsetting } = response.data;
                if (success) {
                    setSettings(emailsetting.length > 0 ? emailsetting : [{ name: '', email: '', designation: '' }]);
                } else {
                    Toast.warning('No saved settings found.');
                }
            } catch (error) {
                Toast.error('Error fetching email settings.');
            }
        };

        fetchSettings();
    }, []);
    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const validateForm = () => {
        for (const setting of settings) {
            if (!setting.name || !setting.email || !setting.designation) {
                Toast.warning('Please fill all fields for each person.');
                return false;
            }
            if (!validateEmail(setting.email)) {
                Toast.warning(`Invalid email format for "${setting.email}".`);
                return false;
            }
        }
        return true;
    };

    const saveSettings = async () => {
        if (!validateForm()) return;
        try {
            const response = await axiosInstance.post('/emailsettings/add', { settings });
            const { success, message } = response.data;
            if (success) {
                Toast.success(message);
                //navigate(-1);
            } else {
                Toast.warning(message);
            }
        } catch (error) {
            Toast.error('Error saving email settings.');
        }
    };

    return (
        <Box display="flex" padding={2} flexDirection="column" minHeight="100vh">
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} flexWrap="wrap">
                <Box display="flex" alignItems="center">
                    <ArrowBack onClick={handleBackClick} style={{ cursor: 'pointer', marginRight: '8px', height: '34px', width: '38px', color: '#545454' }} />
                    <Typography sx={{ fontFamily: 'Times New Roman', fontWeight: '700', fontSize: '32px', color: '#545454' }}>
                        Email Settings
                    </Typography>
                </Box>
                <Box>
                    <ResetButton label="Reset" onClick={resetSettings} />
                    <SaveButton label="Save" onClick={saveSettings} />
                </Box>
            </Box>

            <Paper elevation={3} sx={{ padding: 4 }}>
                {settings.map((setting, index) => (
                    <Box key={index} display="flex" flexDirection="row" flexWrap="wrap" alignItems="center" gap={2} mb={2}>
                        <CustomInputField
                            label="Authorized Person Name"
                            fullWidth
                            value={setting.name}
                            onChange={(e) => handleInputChange(index, 'name', e.target.value)}
                        />
                        <CustomInputField
                            label="Email ID"
                            fullWidth
                            value={setting.email}
                            onChange={(e) => handleInputChange(index, 'email', e.target.value)}
                        />
                        <CustomInputField
                            label="Designation"
                            fullWidth
                            value={setting.designation}
                            onChange={(e) => handleInputChange(index, 'designation', e.target.value)}
                        />
                        <IconButton
                            sx={{ mt: 3, color: '#5C3685' }}
                            onClick={() => deletePerson(index)}
                            aria-label="delete"
                        >
                            <Delete />
                        </IconButton>
                    </Box>
                ))}
                <Box textAlign="center" mt={2}>
                    <SaveButton label="Add" onClick={addNewPerson} />
                </Box>
            </Paper>
        </Box>
    );
};

export default EmailSettings;
